import api from './api';

// class with functions for prediction api
class PredictionService {


  //get prediction data for a ship
  getShipPredictionData(fromDate, toDate, company) {
    let payload = {
      CompanyId: company,
      CurrentDataIntervalMinutes: 10440,
      ReportFrom: fromDate,
      ReportTo: toDate
    };


    return api.post('monitor/', payload);
  }


  //get single prediction data for a ship
  getSingleShipPredictionData(fromDate, toDate, selectedShip, company) {
    let payload = {
      CompanyId: company,
      CurrentDataIntervalMinutes: 10440,
      ReportFrom: fromDate,
      ReportTo: toDate
    };

    return api.post('monitor/' + selectedShip, payload);
  }

  //get detailed prediction data for a ship
  getSingleShipDetailedPredictionData(selectedShip) {
    return api.get('prediction/' + selectedShip);
  }


}

export default new PredictionService();
